window.OnepagerHeader = (function () {

    const $mainNav = $(".js-main-menu a[href*=\"#\"]").not('[href="#"]').not("[href=\"#0\"]");

    function activeMenu($menuLinks) {
        const $scrollActivePosition = $("header").outerHeight() + 24;

        $menuLinks.each(function (i) {
            const href = $(this).attr("href");

            if ($(href).length) {
                if ($(href).offset().top - $(window).scrollTop() < $scrollActivePosition) {
                    $mainNav.removeClass("nav-link-md-active nav-link-active");
                    $(this).addClass("nav-link-md-active nav-link-active");
                    return false;
                }
                else if (i === ($menuLinks.length - 1) && $(href).offset().top - $(window).scrollTop() >= $scrollActivePosition) {
                    $mainNav.removeClass("nav-link-md-active nav-link-active");
                }
            }
        });
    }

    return {
        init: function () {

            activeMenu($mainNav);

            $(window).scroll(function () {
                activeMenu($($mainNav.get().reverse()));
            });

            $mainNav.click(function () {
                if ($(".js-menu-burger").hasClass("burger-menu-icon-active")) {
                    $(".js-menu-burger").toggleClass("burger-menu-icon-active");
                    $(".js-main-menu").toggleClass("main-menu-active");
                    $(".js-main-menu-overlay").toggleClass("main-menu-overlay-active");
                }
            });
        }
    };
})();